module.exports = __webpack_public_path__ + "static/media/login_intro.92242a8e.jpg";